import React, { type PropsWithChildren } from 'react';
import MockAuthContextProvider, { AuthState } from '../auth/MockMsalAuthContextProvider';
import MockChatServiceProvider from '../chat/MockChatServiceProvider';
import MockAppInfoServiceProvider from '../app-info/MockAppInfoServiceProvider';
import MockBackendEventsServiceProvider from '../backend-events/MockBackendEventsServiceProvider';
import MockPromptServiceProvider from '../../features/prompts/contexts/MockPromptServiceProvider';

const MockContextBootstrap: React.FC<PropsWithChildren<{ authState?: Partial<AuthState>; }>> = ({ children, authState: authStateOverride }) => {
    return (
        <MockAuthContextProvider>
            <MockBackendEventsServiceProvider>
                <MockAppInfoServiceProvider>
                    <MockPromptServiceProvider>
                        <MockChatServiceProvider>
                            {children}
                        </MockChatServiceProvider>
                    </MockPromptServiceProvider>
                </MockAppInfoServiceProvider>
            </MockBackendEventsServiceProvider>
        </MockAuthContextProvider >
    );
};

export default MockContextBootstrap;